import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, MenuItem, Select } from '@mui/material';
import styles from './styles';

const MobileSelectDrillDetails = ({ id, value, field, data, updateData, label, decimals, loading }) => {
  const classes = styles();

  const handleChange = (event) => {
    event.stopPropagation();
    event.preventDefault();
    updateData?.(id, field, event.target.value);
  };

  return (
    <FormControl
      variant="filled"
      className={classes.inputField}
      sx={{ bgcolor: 'transparent' }}
    >
      <Select
        labelId={`drill-select-${id}`}
        id={`drill-select-${id}`}
        value={value ?? ''}
        onChange={handleChange}
        disableUnderline
        sx={{
          '.MuiSelect-select': {
            p: '10px',
            fontWeight: 900
          },
        }}
        disabled={loading}
      >
        {data?.map((item, idItem) => (
          <MenuItem
            key={`item_${item?.name}_${idItem}`}
            value={`${item?.name?.trim()} @ ${item?.MD?.toFixed(decimals)}${label}`}
            sx={{ fontSize: '18px', fontWeight: 'bold' }}
          >
            {`${item?.name?.trim()} @ ${item?.MD?.toFixed(decimals)}${label}`}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

MobileSelectDrillDetails.propTypes = {
  field: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  value: PropTypes.any,
  data: PropTypes.array,
  updateData: PropTypes.func,
  label: PropTypes.string,
  decimals: PropTypes.number,
  loading: PropTypes.bool
};

export default MobileSelectDrillDetails;
